import React, { Component } from "react";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import Input from "react-validation/build/input";
import Form from "react-validation/build/form";
import GlobalSession, {
  getToken,
  ShowErrorAlert,
} from "../Common/GlobalSession";
import { toast } from "react-toastify";

class AddUser extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    companyId: GlobalSession.companyId,
    companyName: GlobalSession.companyName,
    universalTemplateList: [],
    templateId: "",
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.success !== prevProps.success && this.props.success) {
      this.getTemplates();
    }
  }

  handleChange = async (event) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;
    await this.setState({
      [name]: value,
    });
    // console.log(event)
  };
  //  resendEmail = async (email,companyId) => {
  //   var self = this;
  //   await axios({
  //       method: 'post',
  //       url: process.env.REACT_APP_API_END_POINT + '/forgetPassword',
  //       data: {
  //           email,
  //           companyId
  //       }
  //   }).then(Response => Response)
  //       .then(res => {
  //           if (res.data && res.data.result && res.data.result.emailstatus === true) {
  //               self.updateEntityActivity(email);
  //               this.props.toggleSuccess();
  //              this.props.toggle();
  //           } else {
  //               alert("Email Not Sent - err:" + JSON.stringify(res.data));
  //           }
  //       }).catch(function (error) {
  //       });

  // }
  updateEntityActivity = async (email) => {
    var loggedInUserEmail = localStorage.getItem("loginUserEmail");
    var inputobj = {
      auditActivityType: "UA",
      logType: "I",
      activity: "RESET",
      entityId: null,
      growthPlanId: null,
      goalTagId: null,
      actionTagId: null,
      meetingId: null,
      page: "",
      auditText: "",
      auditValue: null,
      auditMessage: "Admin(" + loggedInUserEmail + ") has reset the password",
      auditLink: "",
      email: email,
    };
    await axios({
      method: "POST",
      url: process.env.REACT_APP_API_END_POINT + "/updateEntityActivity",
      data: inputobj,
    })
      .then((Response) => Response)
      .then((res) => {
        return res;
      })
      .catch(function (error) {});
  };
  updateEntityUser = async (inputObj) => {
    let tokenStr = getToken();
    this.setState({ loading: true });
    await axios({
      method: "post",
      url: process.env.REACT_APP_API_END_POINT + "/updateEntityPersonal",
      data: inputObj,
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((Response) => Response)
      .then((res) => {
        if (res.data.header.errorCode === 1) {
          toast.error(res.data.header.errorMsg);
          this.props.toggle();
          this.setState({ firstName: "", lastName: "", email: "", loading: false });
        }
        if (res.data.header.errorMsg === "Success") {
          this.props.toggleSuccess();
          this.props.toggle();
          this.setState({ firstName: "", lastName: "", email: "", loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (error.response && error.response.status === 401) {
          ShowErrorAlert(4, error.response.data.error.message);
        }
      });
  };
  updateUserDetails = () => {
    var inputobj = {
      action: "INSERT",
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      companyId: this.state.companyId,
      templateId: this.state.templateId ? this.state.templateId : null,
    };
    var isvalidated = true;
    var errorfield = "";
    if (
      this.state.firstName == null ||
      this.state.firstName == "" ||
      this.state.firstName == undefined ||
      this.state.firstName.trim().length == 0
    ) {
      errorfield = "First Name";
      isvalidated = false;
    } else if (
      this.state.lastName == null ||
      this.state.lastName == "" ||
      this.state.lastName == undefined ||
      this.state.lastName.trim().length == 0
    ) {
      errorfield = "Last Name";
      isvalidated = false;
    } else if (
      this.state.email == null ||
      this.state.email == "" ||
      this.state.email == undefined ||
      this.state.email.trim().length == 0
    ) {
      errorfield = "Email";
      isvalidated = false;
    }

    if (isvalidated) {
      // alert(this.state.companyId);
      this.updateEntityUser(inputobj);
    } else {
      // alert("Enter " + errorfield);
      toast.error(`Enter ${errorfield}`);
    }
    // console.log(this.state)
  };
  getTemplates = async () => {
    var self = this;
    await axios({
      method: "POST",
      url: process.env.REACT_APP_API_END_POINT + "/getTemplates",
      data: {
        companyId: GlobalSession.companyId,
        action: "COMMUNITYGROWTHPLAN",
      },
    })
      .then((Response) => Response)
      .then((res) => {
        if (res.data.result) {
          self.setState({
            universalTemplateList: res.data.result,
          });
        }
      });
  };
  render() {
    return (
      <Modal
        isOpen={this.props.success}
        toggle={() => this.props.toggle()}
        className={"modal-primary"}
        size="xl"
        centered={true}
        backdrop={"static"}
        keyboard={false}
      >
        <ModalHeader>Add User</ModalHeader>
        <ModalBody className="text-center pt-3">
          <Form
            action=""
            autoComplete="off"
            className="form-User mb-3"
            ref="form"
          >
            <Row className="mb-3 d-flex justify-content-center">
              <Col md="5">
                <FormGroup className="d-flex flex-column flex-md-row align-items-center row">
                  <div className="col-md-4">
                    <Label
                      htmlFor="firstName"
                      className="font-weight-bold user-label text-truncate"
                    >
                      First Name <sup className="text-danger">*</sup>
                    </Label>
                  </div>
                  <div className="col-md-8">
                    <Input
                      name="firstName"
                      className="form-control "
                      required
                      type="text"
                      value={this.state.firstName}
                      onChange={this.handleChange}
                      placeholder=""
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mb-3 d-flex justify-content-center">
              <Col md="5">
                <FormGroup className="d-flex flex-column flex-md-row align-items-center row">
                  <div className="col-md-4">
                    <Label
                      htmlFor="lastName"
                      className="font-weight-bold user-label text-truncate"
                    >
                      Last Name <sup className="text-danger">*</sup>
                    </Label>
                  </div>
                  <div className="col-md-8">
                    <Input
                      name="lastName"
                      className="form-control"
                      required
                      type="text"
                      value={this.state.lastName}
                      onChange={this.handleChange}
                      placeholder=""
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mb-3 d-flex justify-content-center">
              <Col md="5">
                <FormGroup className="d-flex flex-column flex-md-row align-items-center row">
                  <div className="col-md-4">
                    <Label
                      htmlFor="email"
                      className="font-weight-bold user-label"
                    >
                      Email <sup className="text-danger">*</sup>
                    </Label>
                  </div>
                  <div className="col-md-8">
                    <Input
                      name="email"
                      className="form-control"
                      required
                      type="text"
                      id="email"
                      placeholder=""
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mb-3 d-flex justify-content-center">
              <Col md="5">
                <FormGroup className="d-flex flex-column flex-md-row align-items-center row">
                  <div className="col-md-4">
                    <Label
                      htmlFor="name"
                      className="font-weight-bold user-label text-truncate ml-3"
                    >
                      Template
                    </Label>
                  </div>
                  <div className="col-md-8">
                    <select
                      type="select"
                      name="templateId"
                      id="templateId"
                      className="form-control"
                      value={this.state.templateId}
                      onChange={(e) => {
                        this.setState({ [e.target.name]: e.target.value });
                      }}
                    >
                      <option value="">Please select a template</option>
                      {this.state.universalTemplateList != null &&
                      this.state.universalTemplateList !== undefined &&
                      this.state.universalTemplateList.length > 0
                        ? this.state.universalTemplateList.map(function (
                            universalTemplateobj
                          ) {
                            return (
                              <option
                                key={universalTemplateobj.teamId}
                                value={universalTemplateobj.teamId}
                              >
                                {universalTemplateobj.NAME}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mb-3 d-flex justify-content-center">
              <Col md="5">
                <FormGroup className="d-flex flex-column flex-md-row align-items-center row">
                  <div className="col-md-4">
                    <Label
                      htmlFor="company"
                      className="font-weight-bold user-label "
                    >
                      Company
                    </Label>
                  </div>
                  <div className="col-md-8"> {this.state.companyName} </div>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            onClick={this.updateUserDetails}
            color="danger"
            disabled={this.state.loading}
          >
            {this.state.loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-1"
                  role="status"
                  aria-hidden="true"
                />
                Saving...
              </>
            ) : (
              "Save"
            )}
          </Button>

          <Button
            size="sm"
            onClick={() => {
              this.props.toggle();
              this.setState({ firstName: "", lastName: "", email: "" });
            }}
            color="primary"
            disabled={this.state.loading}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      // <div/>
    );
  }
}
export default AddUser;
